const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7×24 小时不间断监控各大社交平台热点，网红撕逼、明星丑闻第一时间推送，绝不让你错过任何一个大瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '来源标注',
    desc: '每一条八卦资讯均标注信息来源，公开帖文附原始链接，爆料投稿标注"网友投稿"，不制造不传播虚假信息。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '汇集全网最活跃的吃瓜群众，评论区开放讨论。理性吃瓜、文明交流，一起做最有素质的瓜友。',
  },
  {
    icon: 'ri-survey-line',
    title: '深度扒皮',
    desc: '编辑团队对热点事件进行深度梳理，整理时间线、人物关系和事件全貌，让你一次吃透一个大瓜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">为什么选我们</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料大赛 — 全网最硬核的吃瓜现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-2xl border border-background-200/70 p-6 hover:border-accent-200/50 transition-all duration-300 group cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}